export const userStatus = {
    0: "Inactive",
    1: "Active",
    // ...add all status codes as needed
};

export function getUserInfo() {
    const token = localStorage.getItem('csh_jwt_token');
    if (!token) return { userEmail: '', userRole: '' };
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return { userEmail: payload.sub || '', userRole: payload.role || '' };
    } catch {
        return { userEmail: '', userRole: '' };
    }
}